import i18n from '../../i18n';

const sidebar = {
  bank: {
    key: 'bank',
    to: '/bank',
    title: i18n.t('screen.bank.title'),
    name: i18n.t('screen.bank.name'),
    icon: 'is-mf-bank'
  },
  application: {
    key: 'application',
    to: '/application',
    title: i18n.t('screen.application.title'),
    name: i18n.t('screen.application.name'),
    icon: 'is-mf-application'
  },
  csv: {
    key: 'csv',
    to: '/csv',
    title: i18n.t('screen.csv.title'),
    name: i18n.t('screen.csv.name'),
    icon: 'is-mf-csv'
  },
  tags: {
    key: 'tags',
    to: '/tags',
    title: i18n.t('screen.tag.title'),
    name: i18n.t('screen.tag.name'),
    icon: 'is-mf-tag'
  },
  account: {
    key: 'account',
    to: '/account',
    title: i18n.t('screen.account.title'),
    name: i18n.t('screen.account.name'),
    icon: 'is-mf-account'
  },
  transaction: {
    key: 'transaction',
    to: '/transaction',
    title: i18n.t('screen.transaction.title'),
    name: i18n.t('screen.transaction.name'),
    icon: 'is-mf-transaction'
  }
}

let screens = Object.assign({
  support: {
    key: 'support',
    to: '/support',
    title: i18n.t('screen.support.title'),
    name: i18n.t('screen.support.name'),
  },
  terms: {
    key: 'terms',
    to: '/terms',
    title: i18n.t('screen.terms.title'),
    name: i18n.t('screen.terms.name'),
  },
  terms_of_use: {
    key: 'terms_of_use',
    to: '/terms_of_use',
    title: i18n.t('screen.terms_of_use.title'),
    name: i18n.t('screen.terms_of_use.name'),
  },
  user_setting: {
    key: 'user_setting',
    to: '/user_setting',
    title: i18n.t('screen.user_setting.title'),
    name: i18n.t('screen.user_setting.name')
  }
  // add other screen
}, sidebar);

export { screens,  sidebar};
